import { color, spacing } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { ModalProps, StyleSheet, ViewStyle } from 'react-native';
import { Overlay } from 'react-native-elements/dist/overlay/Overlay';

type DialogSize = 'mc' | 'sm' | 'md' | 'lg' | 'xl' | 'fullscreen';

export interface DialogProps extends ModalProps {
  size?: DialogSize;
  onClose?: () => void;
}

const Dialog: FC<DialogProps> = ({ size = 'md', ...props }) => (
  <Overlay
    animationType="fade"
    transparent
    isVisible
    overlayStyle={StyleSheet.flatten([
      styles.modal,
      sizePresets[size],
      props.style,
    ])}
    onRequestClose={props.onClose}
    onBackdropPress={props.onClose}
    {...props}
  >
    {props.children}
  </Overlay>
);

// Styles
const styles = StyleSheet.create({
  modal: {
    backgroundColor: color.background,
    borderRadius: spacing[4],
    marginBottom: spacing[2],
    marginLeft: 'auto',
    marginRight: 'auto',
    maxHeight: '90%',
    overflow: 'hidden',
    padding: 0,
  },
});

const sizePresets: { [key: string]: ViewStyle } = {
  mc: {
    alignSelf: 'center',
    maxWidth: '100%',
  },
  sm: {
    width: 400,
  },
  md: {
    width: 600,
  },
  lg: {
    width: 900,
  },
  xl: {
    width: '80%',
  },
  fullscreen: {
    width: '95%',
    height: '95%',
    maxHeight: '95%',
  },
};

export default Dialog;
